import React from "react";
import {
  ClipboardCopy,
  NoteTooltip as IconTooltip
} from "MODULES/shared/components";
import classNames from "classnames";
import { getPartNumberColorClassNameByTierType } from "MODULES/shared/helpers";
import { connect } from "react-redux";
import { push } from "react-router-redux";

const Application = ({ application, navToPart }) => {
  const labelClassName = classNames(
    "btn btn-xs btn-default",
    getPartNumberColorClassNameByTierType(application.tier_type)
  );

  let onLabelClick = () => {};
  let labelColor = "#FFFFFF";

  if (application.applicable_uuid) {
    labelColor = "#FF9800";
    onLabelClick = () => navToPart(application.applicable_uuid);
  }

  const labelStyle = {
    cursor: onLabelClick ? "pointer" : "default",
    color: labelColor,
    fontSize: "1.25em"
  };

  return (
    <tr
      className="btn-group"
      style={{ marginBottom: 4, marginRight: 2, width: "100%" }}
    >
      <button
        style={labelStyle}
        type="button"
        className={labelClassName}
        onClick={onLabelClick}
      >
        {application.sellable && (
          <IconTooltip
            note="In Stock"
            url="https://aero-zone-assets.s3.amazonaws.com/inventory.png"
          />
        )}
        {application.label}
      </button>
      <ClipboardCopy name={application.label} type="PN" iconFontSize="1em" />
    </tr>
  );
};

export default connect(undefined, dispatch => ({
  navToPart: partId => dispatch(push(`/parts/${partId}`))
}))(Application);



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/Teardowns/Application.jsx